export type NodeKind = 'trigger' | 'action' | 'subflow' | 'sticky'

export interface NodeOption {
  id: string
  type: NodeKind
  icon: string
  iconUrl?: string | null // URL to SVG icon for rendering
  title: string
  description: string
  category?: string // Optional category for grouping in menu
  colorTheme?: string // Optional color theme
  nodeData?: Record<string, any> // Optional JSON data for node configuration
}

export const nodeOptions: NodeOption[] = [
  // Organization - subflows
  {
    id: 'domain',
    type: 'subflow',
    icon: '🗂️',
    title: 'Domain/Subgraph',
    description: 'Group related assets into a domain or subgraph. Drag nodes in/out to organize your workflow',
    category: 'Organization',
  },
  // Triggers
  {
    id: 'manual',
    type: 'trigger',
    icon: '👆',
    title: 'Start manually',
    description: 'Runs the flow on clicking a button. Good for getting started quickly',
    category: 'Triggers',
  },
  {
    id: 'data-source',
    type: 'trigger',
    icon: '📥',
    title: 'Data Source',
    description: 'Starts the lineage trace from a data source',
    category: 'Triggers',
  },
  {
    id: 'schedule',
    type: 'trigger',
    icon: '⏰',
    title: 'On a schedule',
    description: 'Runs the flow every day, hour, or custom interval',
    category: 'Triggers',
  },
  {
    id: 'webhook',
    type: 'trigger',
    icon: '🔗',
    title: 'On webhook call',
    description: 'Runs the flow on receiving an HTTP request',
    category: 'Triggers',
  },
  {
    id: 'file-change',
    type: 'trigger',
    icon: '📁',
    title: 'On file change',
    description: 'Runs the flow on workflow errors, file changes, etc.',
    category: 'Triggers',
  },
  {
    id: 'error',
    type: 'trigger',
    icon: '⚠️',
    title: 'On workflow error',
    description: 'Runs the flow when errors occur in other workflows. Ideal for error handling and notifications',
    category: 'Triggers',
  },
  // Actions
  {
    id: 'asset',
    type: 'action',
    icon: '📦',
    title: 'Asset',
    description: 'Data asset / transformation step in the lineage',
    category: 'Actions',
  },
  {
    id: 'executed',
    type: 'action',
    icon: '⚙️',
    title: 'When executed by another workflow',
    description: 'Runs the flow when called by the Execute workflow node from a different workflow',
    category: 'Actions',
  },
  // Annotations - sticky notes
  {
    id: 'sticky-note',
    type: 'sticky',
    icon: '📝',
    title: 'Sticky Note',
    description: 'Add a sticky note with markdown support to annotate your workflow',
    category: 'Annotations',
  },
  // PROJ-061: Loop Control Nodes
  {
    id: 'BREAK',
    type: 'action',
    icon: '⏹️',
    title: 'Romper Loop (Break)',
    description: 'Detiene el loop inmediatamente y pasa al siguiente paso despues del loop',
    category: 'Flujo',
    colorTheme: '#dc2626',
    nodeData: {
      code: 'BREAK',
    },
  },
  {
    id: 'CONTINUE',
    type: 'action',
    icon: '⏭️',
    title: 'Saltar a Siguiente (Continue)',
    description: 'Salta al siguiente item del array sin ejecutar los nodos restantes de esta iteracion',
    category: 'Flujo',
    colorTheme: '#2563eb',
    nodeData: {
      code: 'CONTINUE',
    },
  },
  // PROJ-065: PDF Generation
  {
    id: 'PDF_OPERATION',
    type: 'action',
    icon: '📄',
    title: 'Generar PDF',
    description: 'Genera PDFs profesionales desde JSON, Markdown o HTML',
    category: 'Documentos',
    colorTheme: '#dc2626',
    nodeData: {
      code: 'PDF_OPERATION',
    },
  },
  // Incident Integration (Legacy ARCO - use Apps category for new workflows)
  {
    id: 'CREATE_INCIDENT',
    type: 'action',
    icon: '🎫',
    title: 'Crear Incidente ARCO',
    description: 'Crea un incidente ARCO con persona/empresa y cascada de entidades',
    category: 'Incidentes',
    colorTheme: '#ef4444',
    nodeData: {
      code: 'CREATE_INCIDENT',
    },
  },
  {
    id: 'ATTACH_EVIDENCE',
    type: 'action',
    icon: '📎',
    title: 'Adjuntar Evidencia',
    description: 'Adjunta archivos (ej: PDFs) a un incidente como evidencia',
    category: 'Incidentes',
    colorTheme: '#f59e0b',
    nodeData: {
      code: 'ATTACH_EVIDENCE',
    },
  },
]
